import React, { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { BasePathProvider } from '../font-explorer/context/BasePathContext'
import { FavoritesProvider, useFavoritesContext } from '../shared/FavoritesContext'
import PairingsIndex from '../font-explorer/components/PairingsIndex'
import PairingCategory from '../font-explorer/components/PairingCategory'
import AllPairings from './components/AllPairings'
import CreatePairingPage from './components/CreatePairingPage'
import ToolNav from '../shared/ToolNav'

function AppContent() {
  const [refreshKey, setRefreshKey] = useState(0)
  const { isPairingFavorited, isPairingSortFavorited, togglePairing, authenticated, pairingSortSnapshot } = useFavoritesContext()

  const createButton = (
    <a
      href="/font-pairings/new"
      className="flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-gray-900 bg-white rounded hover:bg-gray-100 transition-colors cursor-pointer"
    >
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
      </svg>
      New Pairing
    </a>
  )

  return (
    <>
      <ToolNav current="/font-pairings" action={createButton} />
      <BasePathProvider value="/font-pairings">
        <Routes>
          <Route path="/font-pairings/new" element={<CreatePairingPage />} />
          <Route
            path="/font-pairings"
            element={<PairingsIndex refreshKey={refreshKey} />}
          />
          <Route
            path="/font-pairings/all"
            element={
              <AllPairings
                refreshKey={refreshKey}
                isPairingFavorited={isPairingFavorited}
                isPairingSortFavorited={isPairingSortFavorited}
                togglePairing={togglePairing}
                authenticated={authenticated}
                pairingSortSnapshot={pairingSortSnapshot}
              />
            }
          />
          <Route path="/font-pairings/:categoryId" element={
            <PairingCategory
              isPairingFavorited={isPairingFavorited}
              togglePairing={togglePairing}
              authenticated={authenticated}
            />
          } />
          <Route path="*" element={<Navigate to="/font-pairings" replace />} />
        </Routes>
      </BasePathProvider>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <FavoritesProvider rootElementId="font-pairings">
        <AppContent />
      </FavoritesProvider>
    </BrowserRouter>
  )
}
